import { Component, OnInit, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core'; // Added ChangeDetectorRef
import { Router } from '@angular/router';
import { Auth, User as FirebaseUser, authState, signOut, sendPasswordResetEmail, signInWithEmailAndPassword, updateEmail, updatePassword, deleteUser, EmailAuthProvider, reauthenticateWithCredential } from '@angular/fire/auth'; // Updated Auth imports
import { Auth as FirebaseSDKAuth } from '@firebase/auth'; // Import underlying Auth type for casting
import { Firestore, collection, doc, docData, setDoc, CollectionReference, DocumentReference } from '@angular/fire/firestore'; // Updated Firestore imports
import { Storage, ref, getDownloadURL, uploadBytes } from '@angular/fire/storage'; // Updated Storage imports
// Removed firebase/compat/app import
import { User } from 'src/app/_models/user'; // Keep local User model
import { MessageService } from 'primeng/api';
import { Observable, of, pipe, firstValueFrom } from 'rxjs'; // Added firstValueFrom
import { map, filter, tap } from 'rxjs/operators';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { Config } from 'src/app/_models/config';
import { SharedService } from 'src/app/services/shared.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Component({
  selector: 'app-user-manage',
  templateUrl: './user-manage.component.html',
  styleUrls: ['./user-manage.component.scss'],
  providers: [MessageService]
})
export class UserManageComponent implements OnInit {

  public user: User | undefined; // Allow undefined initially
  public firebaseUser: FirebaseUser | null = null; // Use FirebaseUser type from @angular/fire/auth
  public role : string;
  public password: string;
  public newPassword: string;
  public newPassword2: string;
  
  public config: Config;
  public downloadURL : string | undefined; // Changed type from Observable<string>
  public maxContent = 1;
  maxImageSize: number = 10000000;
  attachments: any[] = [];
  status: "initial" | "uploading" | "success" | "fail" = "initial"; // Variable to store file status
  file: File | null = null; // Variable to store file
  clientLookupStarted: boolean;
  clientData: any;

  @ViewChild('changeEmailDialog') changeEmailDialog : ElementRef;
  @ViewChild('changePasswordDialog') changePasswordDialog : ElementRef;
  @ViewChild('deleteAccountDialog') deleteAccountDialog : ElementRef;

  private userCollection: CollectionReference<User>; // Updated type

  constructor(
      private firestore: Firestore, // Updated injection
      private auth: Auth, // Updated injection
      private router:Router,
      private messageService: MessageService,
      private storage: Storage, // Updated injection
      private myanalytics: AnalyticsService,
      private sharedService: SharedService,
      private http: HttpClient,
      private cdr: ChangeDetectorRef) { // Added ChangeDetectorRef

    this.userCollection = collection(this.firestore, 'users') as CollectionReference<User>; // Use modular collection
    authState(this.auth as FirebaseSDKAuth).subscribe(firebaseUser => { // Cast Auth to underlying SDK type
      this.firebaseUser = firebaseUser;
      if(firebaseUser != null) {
        this.loadConfig();
      } else {
        // Handle user logged out state if necessary
        this.user = undefined;
        this.role = '';
      }
    });
    // sharedService.currentUser$.subscribe((user) => {
    //   if(user != undefined) {
    //     this.user = user;
    //     this.role = user.role;
    //   }
    // });
  }

  ngOnInit(): void {
    
  }

  loadConfig() {
    const configDocRef = doc(this.firestore, "config/Config") as DocumentReference<Config>; // Create typed doc ref
    docData(configDocRef).pipe(map(async (value) => { // Use docData
      if(value === undefined) {
        let config = new Config();
        config.headerColour = "#0D4131";
        config.bgColour = "#EDF0EE";
        config.buttonColour = "#ffffff";
        config.buttonTextColour = "#000000";
        this.config = config;
        const plainConfigObject = JSON.parse(JSON.stringify(config));
        await setDoc(configDocRef, plainConfigObject); // Use setDoc
      }
      else {
        this.config = value as Config; // Cast Firestore data to local Config type
        if(this.config.headerColour === undefined) {
          this.config.headerColour = "#0D4131";
          this.config.bgColour = "#EDF0EE";
          this.config.buttonColour = "#ffffff";
          this.config.buttonTextColour = "#000000";
        }
        if(value.clientId !== undefined)
          this.lookupClientInfo(value.clientId as string); // Cast clientId to string
      }

      const filePath = this.config?.image;
      if(filePath !== undefined) {
        await this.loadLogo(filePath); // Await logo loading
      } else {
        this.downloadURL = undefined; // Clear URL if no path
        this.cdr.detectChanges();
      }
    })).subscribe();
  }

  lookupClientInfo(clientId: string) {
    if(!this.clientLookupStarted) {
      this.clientLookupStarted = true;
      let url = `https://us-central1-gallariepurchase.cloudfunctions.net/lookupClientHttp?clientId=${clientId}`;
      let headers = new HttpHeaders();
      headers = headers.set('Content-Type', 'application/json; charset=utf-8');
      this.http.post(url, {headers: headers})
        .subscribe(data => {
          const json = JSON.parse(JSON.stringify(data));
          console.log(json);
          this.clientLookupStarted = false;
          this.clientData = json.data;
        },
        error => {
          const json = JSON.parse(JSON.stringify(error));
          console.error("Error: " + json);
          this.clientLookupStarted = false;
        }
      );
    }
  }

  resetColours() {
    this.config.headerColour = "#0D4131";
    this.config.bgColour = "#EDF0EE";
    this.config.buttonColour = "#ffffff";
    this.config.buttonTextColour = "#000000";
  }

  saveConfig() {
    const configDocRef = doc(this.firestore, "config/Config") as DocumentReference<Config>; // Create typed doc ref
    const plainConfigObject = JSON.parse(JSON.stringify(this.config));
    setDoc(configDocRef, plainConfigObject).then(() => { // Use setDoc
      this.messageService.add({severity:'success', summary:'Success', detail:"Settings Updated"});
    });
  }

  private async loadLogo(filePath: string) { // Make async
    if(filePath !== undefined) {
       try {
          const storageRef = ref(this.storage, filePath); // Use modular ref
          this.downloadURL = await getDownloadURL(storageRef); // Use modular getDownloadURL
          this.cdr.detectChanges(); // Trigger change detection
        } catch (error) {
          console.error("Error getting logo URL:", error);
          this.downloadURL = undefined;
        }
    } else {
       this.downloadURL = undefined;
    }
  }

  public signOut() {
    // this.sharedService.currentUser$.next(null);
    //   signOut(this.auth).then(()=> { // Use modular signOut
    //       this.router.navigate(['/auth/sign-in']);
    //   }).catch(error => {
    //       console.error("Sign out error:", error);
    //   });
  }

  public async changeEmail() { // Make async
    if (!this.firebaseUser || !this.user || !this.password || !this.user.email) {
      this.messageService.add({severity:'warn', summary:'Missing Info', detail:"Please provide current password and new email."});
      return;
    }
    this.myanalytics.logEvent("button_click", {button: "ChangeEmail", user: this.firebaseUser.uid}); // Use uid

    try {
      // Re-authenticate
      const credential = EmailAuthProvider.credential(this.firebaseUser.email!, this.password);
      await reauthenticateWithCredential(this.firebaseUser, credential);

      // Update email
      await updateEmail(this.firebaseUser, this.user.email);

      // Update Firestore user doc (optional, if email is stored there too)
      await this.saveUser(this.user);

      this.messageService.add({severity:'success', summary:'Success', detail:"Email Updated"});
      this.changeEmailDialog.nativeElement.close();
      this.password = ''; // Clear password field

    } catch (error) {
      console.error("Change email error:", error);
      let detail = 'Failed to update email. Please check your password.';
      if (error.code === 'auth/wrong-password') {
        detail = 'Incorrect current password.';
      } else if (error.code === 'auth/email-already-in-use') {
        detail = 'This email address is already in use.';
      } else if (error.code === 'auth/invalid-email') {
         detail = 'The new email address is invalid.';
      }
      this.messageService.add({severity:'error', summary:'Error', detail: detail});
    }
  }

  public async changePassword() { // Make async
     if (!this.firebaseUser || !this.password || !this.newPassword || !this.newPassword2) {
      this.messageService.add({severity:'warn', summary:'Missing Info', detail:"Please provide current and new passwords."});
      return;
    }
    this.myanalytics.logEvent("button_click", {button: "ChangePassword", user: this.firebaseUser.uid}); // Use uid

    if(this.newPassword !== this.newPassword2) {
      console.error("Passwords don't match");
      this.messageService.add({severity:'error', summary:'Error', detail:"New passwords don't match"});
      return;
    }

    try {
      // Re-authenticate
      const credential = EmailAuthProvider.credential(this.firebaseUser.email!, this.password);
      await reauthenticateWithCredential(this.firebaseUser, credential);

      // Update password
      await updatePassword(this.firebaseUser, this.newPassword);

      this.messageService.add({severity:'success', summary:'Success', detail:"Password Updated"});
      this.changePasswordDialog.nativeElement.close();
      this.password = ''; // Clear password fields
      this.newPassword = '';
      this.newPassword2 = '';

    } catch (error) {
       console.error("Change password error:", error);
      let detail = 'Failed to update password. Please check your current password.';
      if (error.code === 'auth/wrong-password') {
        detail = 'Incorrect current password.';
      } else if (error.code === 'auth/weak-password') {
         detail = 'The new password is too weak.';
      }
      this.messageService.add({severity:'error', summary:'Error', detail: detail});
    }
  }

  public async deleteAccount() { // Make async
    if (!this.firebaseUser || !this.user || !this.password) {
       this.messageService.add({severity:'warn', summary:'Missing Info', detail:"Please provide your current password to delete the account."});
      return;
    }
    this.myanalytics.logEvent("button_click", {button: "DeleteAccount", user: this.firebaseUser.uid}); // Use uid

    try {
       // Re-authenticate
      const credential = EmailAuthProvider.credential(this.firebaseUser.email!, this.password);
      await reauthenticateWithCredential(this.firebaseUser, credential);

      // Mark user as deleted in Firestore first (optional but good practice)
      this.user.deleted = true;
      await this.saveUser(this.user);

      // Delete Firebase Auth user
      await deleteUser(this.firebaseUser);

      this.messageService.add({severity:'success', summary:'Success', detail:"Account Deleted"});
      this.password = ''; // Clear password
      setTimeout(()=>{
        this.signOut(); // Sign out after deletion
      }, 1000);

    } catch (error) {
      console.error("Delete account error:", error);
      let detail = 'Failed to delete account. Please check your password.';
      if (error.code === 'auth/wrong-password') {
        detail = 'Incorrect current password.';
      }
      // Revert Firestore deletion status if Auth deletion fails? Consider implications.
      // this.user.deleted = false;
      // await this.saveUser(this.user);
      this.messageService.add({severity:'error', summary:'Error', detail: detail});
    }
  }

  public async saveUserDetails() { // Make async
    if (!this.user) return;
    try {
      await this.saveUser(this.user);
      this.messageService.add({severity:'success', summary:'Success', detail:"Details Updated"});
    } catch (error) {
       console.error("Error saving user details:", error);
       this.messageService.add({severity:'error', summary:'Error', detail:"Failed to save details."});
    }
  }

  public saveUser(user: User): Promise<void> { // Return Promise<void>
    if (!user || !user.id) {
      console.error("User or user ID is missing");
      return Promise.reject("User or user ID is missing");
    }
    console.log("Saving user:", user.id);
    const userDocRef = doc(this.firestore, 'users', user.id); // Use modular doc
    // Convert class instance to plain object for setDoc
    const plainUserObject = JSON.parse(JSON.stringify(user));
    return setDoc(userDocRef, plainUserObject); // Use setDoc, returns Promise<void>
  }

  public resetEmail() :void {
    if (!this.user || !this.user.email) return;
    this.myanalytics.logEvent("button_click", {button: "ResetEmail", user: this.user.id}); // Keep user.id if it's from your User model
    sendPasswordResetEmail(this.auth, this.user.email).then(() => { // Use modular sendPasswordResetEmail
      this.messageService.add({severity:'success', summary:'Email Sent', detail:'Please check your mailbox for instructions.'});
    }).catch(error=>{
       console.error("Password reset error:", error);
       let detail = 'Failed to send password reset email.';
        if (error.code === 'auth/user-not-found') {
          detail = 'No user found with this email address.';
        }
      this.messageService.add({severity:'error', summary:'Error', detail: detail});
    });
  }

  // On file Select
  onChange(event: any) {
    console.log("onChange");
    const file: File = event.target.files[0];

    if (file) {
      this.status = "initial";
      this.file = file;
      this.uploadFiles(file);
    }
  }

  private getFileType(file: any) {
    switch (file.name.substring(file.name.lastIndexOf('.')+1)) {
      case 'mp4':
      case 'mov':
      case 'avi':
      case 'mpg':
      case 'mkv':
        return "video";
      default:
        return "image";
    }
  }

  private uploadFiles(file: File) : void {
    if (!this.user) return; // Add null check
    this.myanalytics.logEvent("button_click", {button: "CompanyLogo", user: this.user.id}); // Keep user.id if it's from your User model
    console.log(file.type);

    if(file.type.startsWith('image')) {
        // Keep original filename but ensure safe characters if needed
        const safeFileName = file.name.replace(/[^a-zA-Z0-9.]/g, '_');
        const filePath = `config/${safeFileName}`;
        const storageRef = ref(this.storage, filePath); // Use modular ref
        this.config.image = filePath; // Update config path

        // Determine content type
        const contentType = file.type || 'application/octet-stream';

        uploadBytes(storageRef, file, { contentType: contentType }) // Use uploadBytes
          .then(async (snapshot) => {
            console.log('Uploaded logo!', snapshot);
            this.downloadURL = await getDownloadURL(storageRef); // Get URL after upload
            this.saveConfig(); // Save config with new path
            this.cdr.detectChanges(); // Trigger change detection
          })
          .catch(error => {
            console.error("Error uploading logo:", error);
            this.messageService.add({severity:'error', summary:'Upload Error', detail:"Failed to upload logo."});
            this.status = "fail"; // Update status on failure
          });
      } else {
         this.messageService.add({severity:'warn', summary:'Invalid File', detail:"Please select an image file."});
      }
  }
}
